export default {
    title: 'Shipments',
    reports: 'Shipments',
    shipmentId: 'Shipment ID',
    usManager: 'US Manager',
    recipient: 'Recipient',
    itemsCount: 'Items Count',
    shipmentDate: 'Shipment Date',
    created: 'Created',
    totalPrice: 'Total Price',
    paid: 'Paid',
    outstanding: 'Outstanding',
    status: 'Status',
    actions: 'Actions',
    open: 'Open',
    closed: 'Closed',
    createShipment: 'Create Shipment',
    full: 'Full',
    partial: 'Partial',
    unpaid: 'Unpaid',
    search: 'Search',
    resetFilters: 'Reset Filters',
    rowsPerPage: 'Rows per page',
    noDataAvailable: 'No data available',
    unknown: 'Unknown',
    shipmentDetails: 'Shipment Details',
    documentNumber: 'Document Number',
    viewDocument: 'View Document',
    viewClosedDocument: 'View Closed Document',
    createdBy: 'Created By',
    employee: 'Employee',
    items: 'Items',
    notFound: 'Shipment not found',
    addItem: 'Add Item',
    wigId: 'Wig ID',
    price: 'Price',
    remaining: 'Remaining',
    totalPaid: 'Total Paid',
    cancel: 'Cancel',
    create: 'Create',
    addAtLeastOneItem: 'Please add at least one item',
    createError: 'Error creating shipment',
    selectUser: 'Wig Stylist',
    selectWigs: 'Select Wigs',
    selectUserFirst: 'Please select a wig stylist first',
    selectManager: 'Please select manager',
    noWigsAvailable: 'No wigs available for this user',
    barcode: 'Barcode',
    description: 'Description (optional)',
    required: 'Required',
    priceMustBePositive: 'Price must be greater than 0',
    userRequired: 'Wig stylist selection is required',
    atLeastOneWigRequired: 'Please select at least one wig',
    allWigsMustHaveBarcode: 'All selected wigs must have a barcode',
    allWigsMustHavePrice: 'All selected wigs must have a price greater than 0',
    errorLoadingUsers: 'Error loading users',
    errorLoadingWigs: 'Error loading wigs',
    crumbs: [{ title: 'Home' }],
    client: 'Client',
    clientWithStylist: 'Client - Wig Stylist',
    returnToShipments: 'Return to Shipments',
    selectWigsToAdd: 'Select wigs from the left to add items',
    document: 'Document',
    selectRecipient: 'Select Recipient',
    recipientFirstName: 'Recipient First Name',
    recipientLastName: 'Recipient Last Name',
    recipientName: 'Recipient Name',
    errorLoadingRecipients: 'Error loading recipients',
    recipientFirstNameRequired: 'Recipient first name is required',
    recipientLastNameRequired: 'Recipient last name is required',
    recipientNameRequired: 'Recipient name is required',
    recipientRequired: 'Recipient selection is required',
    editWig: 'Edit Wig',
    editWigBarcode: 'Edit Wig Barcode',
    confirm: 'Confirm',
    barcodeUpdated: 'Barcode updated successfully',
    errorUpdatingBarcode: 'Error updating barcode',
    wigNotFound: 'Wig not found',
    close: 'Payment',
    closeSelected: 'Payment Selected',
    closeAll: 'Payment All',
    itemClosed: 'Item closed successfully',
    itemsClosed: 'Items closed successfully',
    allItemsClosed: 'All items closed successfully',
    closeError: 'Error closing items',
    confirmCloseItem: 'Are you sure you want to close this item?',
    confirmCloseItems:
        'Are you sure you want to close {count} selected item(s)?',
    confirmCloseAllItems:
        'Are you sure you want to close all items in this shipment?',
    sender: 'Sender',
    addSender: 'Add Wig Stylist',
    senderRequired: 'Sender is required',
    allSendersRequired: 'All sender fields must be filled',
    addPayments: 'Add Payments',
    requiredAmount: 'Required Amount',
    totalPayments: 'Total Payments',
    noPaymentsAdded: 'No payments added yet',
    confirmAndClose: 'Confirm and Payment',
    overpaymentError: 'Overpayment: {amount}',
    underpaymentError: 'Underpayment: {amount}',
    noDocumentsSelected: 'No documents selected',
    payments: 'Payments',
    totalAmount: 'Total Amount',
    errorConfirmingPayments: 'Error confirming payments',
    shipments: 'Shipments',
    shipmentItems: 'Shipment Items',
    allItemsAlreadyClosed: 'All selected items are already closed',
    wig: 'Wig',
    closedAt: 'Closed at',
    receipts: 'Receipts',
    receipt: 'Receipt',
    noReceipts: 'No receipts',
    receiptAmount: 'Amount',
    receiptSource: 'Source',
    receiptDate: 'Date',
    return: 'Return',
    returnSelected: 'Return Selected',
    returnAll: 'Return All',
    itemReturned: 'Item returned successfully',
    itemsReturned: 'Items returned successfully',
    allItemsReturned: 'All items returned successfully',
    returnError: 'Error returning items',
    confirmReturnItem: 'Are you sure you want to return this item?',
    confirmReturnItems: 'Are you sure you want to return {count} selected item(s)?',
    confirmReturnAllItems: 'Are you sure you want to return all items in this shipment?',
    returned: 'Returned',
    returnedAt: 'Returned at',
    returnDocumentNumber: 'Return Document Number',
    viewReturnDocument: 'View Return Document',
    cannotReturnItem: 'Cannot return item',
    itemAlreadyReturned: 'Item is already returned',
    itemHasPayments: 'Item has payments and cannot be returned',
    itemIsClosed: 'Item is closed and cannot be returned',
    returnComment: 'Return Comment',
    returnCommentPlaceholder: 'Enter return reason (optional)',
    multipleCurrenciesError:
        'You are trying to create a shipment with multiple currencies. Only one currency is allowed per shipment.',
    bulkOperationResults: 'Bulk Operation Results',
    bulkOperationPartialSuccess:
        '{processed} out of {total} items processed successfully. Some items failed.',
    bulkOperationAllSuccess: 'All items processed successfully',
    failedItems: 'Failed Items',
    successfulItems: 'Successful Items',
    shipmentItemId: 'Shipment Item ID',
    allItemsAlreadyReturned: 'All selected items are already returned',
    confirmRemoveSenderWithItems:
        'This wig stylist has selected items. Are you sure you want to remove them? All their selected items will be lost.',
}
